import { Popup } from '@paywithextend/components'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { matchPath } from 'react-router'
import { createClearCognitoChangePasswordErrorsAction } from 'src/app/ChangePassword/redux/changePassword.actions'
import ChangePasswordForm from 'src/components/ChangePasswordForm/ChangePasswordForm'
import { closeModal } from 'src/navigation/Lnk'
import { changePasswordUrl } from 'src/navigation/urls'
import { selectEmailFromState } from 'src/redux/selectors/auth.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

const ChangePassword = (): React.ReactElement => {
  const email = useSelector(selectEmailFromState)
  const location = useSelector(selectLocationFromState)

  const dispatch = useDispatch()

  useEffect(() => {
    matchPath(location.pathname, changePasswordUrl()) &&
      dispatch(createClearCognitoChangePasswordErrorsAction())
  }, [location])

  return (
    <Popup
      showCloseButton
      onClickClose={(): void => {
        dispatch(closeModal())
      }}
    >
      <ChangePasswordForm email={email} />
    </Popup>
  )
}

export default ChangePassword
